import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Moody%20abstract%20editorial%20backdrop%20made%20of%20layered%20dark%20charcoal%20and%20deep%20vermilion%20paper%20textures%20with%20subtle%20golden%20light%20streaks%2C%20dramatic%20soft%20lighting%2C%20cinematic%20depth%2C%20minimal%20composition%20without%20text%2C%20refined%20atmospheric%20atmosphere&width=1920&height=1080&seq=hl-hero-01&orientation=landscape"
          alt="黑料官方声明辟谣澄清信息平台的深色纸张质感背景"
          title="黑料官方声明辟谣澄清信息平台"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/60 to-black/80" />

      <div className="relative mx-auto w-full max-w-content px-4 py-20 md:px-6 md:py-28">
        <p className="animate-fade-up inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-100">
          <span className="flex h-4 w-4 items-center justify-center"><i className="ri-verified-badge-line" /></span>
          官方信息发布 · 全文归档 · 来源可溯
        </p>

        <h1 className="animate-fade-up delay-1 mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
          {siteInfo.name}
        </h1>
        <p className="animate-fade-up delay-2 mt-4 max-w-2xl font-heading text-xl text-accent-200 md:text-3xl">
          {siteInfo.tagline}
        </p>
        <p className="animate-fade-up delay-3 mt-5 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">
          {siteInfo.intro}
        </p>

        <div className="animate-fade-up delay-4 mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/statements"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <span className="flex h-4 w-4 items-center justify-center"><i className="ri-book-2-line" /></span>
            浏览声明公告库
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer"
          >
            <span className="flex h-4 w-4 items-center justify-center"><i className="ri-send-plane-line" /></span>
            提交核实线索
          </Link>
        </div>
      </div>
    </section>
  );
}